interface CalendarDay {
	day: number;
	isCurrentMonth: boolean;
	isCurrentDay: boolean;
	isWeekEndDay: boolean;
	isNonWorkingDay: boolean;
	date: Date;
}

interface IAbsenceStyle {
	backgroundColor: string;
	color: string;
	borderColor: string;
	borderStyle: "solid" | "dashed";
}

/**
 * Enum des états simplifiés
 */
enum AbsenceStateEnum {
	Validated = "validated",
	PendingValidation = "pending-validation",
	PendingCancellation = "pending-cancellation"
}

export {
	CalendarDay,
	IAbsenceStyle,
	AbsenceStateEnum
};



// WEBPACK FOOTER //
// ./src/shared/interfaces/calendar.interface.ts